import { ICiudad } from '../../core/interfaces/cities.interface';

export class GetAllCitiesAction {
  static readonly type = '[Cities] Get All';
  constructor() {}
}

export class AddCityAction {
  static readonly type = '[Cities] Add New City';
  constructor(public payload: ICiudad) {}
}

export class UpdatedCityAction {
  static readonly type = '[Cities] Updated';
  constructor(public payload: ICiudad) {}
}

export class DeleteCityAction {
  static readonly type = '[Cities] Delete';
  constructor(public payload: ICiudad) {}
}
